import React, { Component } from "react";

import BackHeader from "../../components/BackHeader";
import checkIcon from "../../images/check-mark-active.png";

class DirectCarrierServicing extends Component {
  backToMenu() {
    this.props.history.goBack();
  }

  render() {
    return (
      <div className="direct-carrier">
        <BackHeader text="Reference Tools" onClick={() => this.backToMenu()} />
        <h1 className="mb-5">Direct Carrier Servicing </h1>
        <table>
          <thead>
            <tr>
              <th>Carrier</th>
              <th>Contact Information</th>
              <th>Billing</th>
              <th>Changes</th>
              <th>Cancellations</th>
              <th>Certificates of Insurance</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Capitol Indemnity</td>
              <td>
                Phone: <b>(888) 541-0481</b>
              </td>
              <td>
                <img src={checkIcon} alt="" />
              </td>
              <td />
              <td />
              <td />
            </tr>
            <tr>
              <td>CNA</td>
              <td>
                Accepts calls from the agent and insured
                <br />
                <br />
                Service Center Items:
                <br />
                <b>(800) 742-9705</b>
                <br />
                <br />
                Changes &amp; Cancellations: <br />
                <a href="mailto:sbiccsr@cna.com">sbiccsr@cna.com</a>
                <br />
                <br />
                NOTE: agents will be required to identify themselves as an NEA
                sub-producer code (TX: 053093, CA: 056919, all other states:
                052011) and provide NEA’s home office address and phone number:
                <br />
                <br />
                6467 Main St., Ste. 104
                <br />
                Williamsville, NY 14221; Phone:
                <br />
                <b>800.333.0980</b>
              </td>
              <td>
                <img src={checkIcon} alt="" />
              </td>
              <td>
                <img src={checkIcon} alt="" />
              </td>
              <td>
                <img src={checkIcon} alt="" />
              </td>
              <td>
                <img src={checkIcon} alt="" />
              </td>
            </tr>
            <tr>
              <td>The Hartford</td>
              <td>
                Service Center Items:
                <br />
                <b>(800) 375-0506</b>
                <br />
                <br />
                Changes &amp; Cancellations: <br />
                <a href="mailto:agency.services@thehartford.com">
                  agency.services@thehartford.com
                </a>
              </td>
              <td>
                <img src={checkIcon} alt="" />
              </td>
              <td>
                <img src={checkIcon} alt="" />
              </td>
              <td>
                <img src={checkIcon} alt="" />
              </td>
              <td>
                <img src={checkIcon} alt="" />
              </td>
            </tr>
            <tr>
              <td>Liberty Agency Underwriters</td>
              <td>
                Service Center Items:
                <br />
                <b>(800) 962-7132</b>
                <br />
                <br />
                Changes &amp; Cancellations: <br />
                (does not apply in CA) <br />
                <a href="mailto:businessservice@libertymutual.com">
                  businessservice@libertymutual.com
                </a>
                <br />
                <br />
                Changes &amp; Cancellations: <br />
                (CA Only) <br />
                <a href="mailto:csusbi@safeco.com">csusbi@safeco.com</a>
              </td>
              <td>
                <img src={checkIcon} alt="" />
              </td>
              <td>
                <img src={checkIcon} alt="" />
              </td>
              <td>
                <img src={checkIcon} alt="" />
              </td>
              <td>
                <img src={checkIcon} alt="" />
              </td>
            </tr>
            <tr>
              <td>MSA</td>
              <td>
                Service Center Items:
                <br />
                <b>(866) 676-3849</b>
                <br />
                <br />
                Changes &amp; Cancellations: <br />
                <a href="mailto:servicecenter@msagroup.com">
                  servicecenter@msagroup.com
                </a>
                <br />
                <br />
                Billing/Payment:
                <br />
                <b>(888) 333-4014</b>
              </td>
              <td>
                <img src={checkIcon} alt="" />
              </td>
              <td>
                <img src={checkIcon} alt="" />
              </td>
              <td>
                <img src={checkIcon} alt="" />
              </td>
              <td>
                <img src={checkIcon} alt="" />
              </td>
            </tr>
            <tr>
              <td>National General (Auto)</td>
              <td>
                Service Center Items:
                <br />
                <b>(877) 468-3466</b>
              </td>
              <td>
                <img src={checkIcon} alt="" />
              </td>
              <td>
                <img src={checkIcon} alt="" />
              </td>
              <td>
                <img src={checkIcon} alt="" />
              </td>
              <td>
                <img src={checkIcon} alt="" />
              </td>
            </tr>
            <tr>
              <td>Progressive</td>
              <td>
                Service Center Items:
                <br />
                <b>(800) 876-7206</b>
              </td>
              <td>
                <img src={checkIcon} alt="" />
              </td>
              <td>
                <img src={checkIcon} alt="" />
              </td>
              <td>
                <img src={checkIcon} alt="" />
              </td>
              <td>
                <img src={checkIcon} alt="" />
              </td>
            </tr>
            <tr>
              <td>RLI</td>
              <td>
                Service Center Items:
                <br />
                <b>(866) 302-7925</b>
              </td>
              <td>
                <img src={checkIcon} alt="" />
              </td>
              <td />
              <td />
              <td />
            </tr>
            <tr>
              <td>Tapco</td>
              <td>
                Service Center Items:
                <br />
                <b>(866) 682-7726</b>
              </td>
              <td>
                <img src={checkIcon} alt="" />
              </td>
              <td>
                <img src={checkIcon} alt="" />
              </td>
              <td>
                <img src={checkIcon} alt="" />
              </td>
              <td>
                <img src={checkIcon} alt="" />
              </td>
            </tr>
            <tr>
              <td>Travelers</td>
              <td>
                Service Center Items:
                <br />
                (does not apply to CA) <br />
                <b>(888) 661-3938</b>
                <br />
                Travelers Billing/Payments:
                <br />
                <b>(800) 252-2268</b>
                <br />
                Changes &amp; Cancellations: <br />
                <a href="mailto:service.center@travelers.com">
                  service.center@travelers.com
                </a>
              </td>
              <td>
                <img src={checkIcon} alt="" />
              </td>
              <td>
                <img src={checkIcon} alt="" />
              </td>
              <td>
                <img src={checkIcon} alt="" />
              </td>
              <td>
                <img src={checkIcon} alt="" />
              </td>
            </tr>
            <tr>
              <td>Zurich/US Assure</td>
              <td>
                Service Center Items:
                <br />
                <b>(866) 279-8253</b>
              </td>
              <td>
                <img src={checkIcon} alt="" />
              </td>
              <td>
                <img src={checkIcon} alt="" />
              </td>
              <td>
                <img src={checkIcon} alt="" />
              </td>
              <td>
                <img src={checkIcon} alt="" />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

export default DirectCarrierServicing;
